<template>
  <div class="Home">
    <SideBar></SideBar>

    <!-- banner -->
    <!-- <Banner :list="list" /> -->
    <!-- 版心 -->
    <div class="_center WidCon">
      <!-- 切换显示内容 -->
      <div class="conent">
        <div class="conent_box">
          <h3>行业与政策</h3>
          <!-- <i class="selected"></i> -->
          <p class="industry_text1">
            我们正在进入一个万物感知、万物互联、万物智能的智慧社会，物联网正在引领行业创新与变革，渗透与改变人民生活。国家政府对物联网产业投以极大的关注及支持，使得物联网产业发展迅速，已经逐渐从未来愿景走向现实应用。同时教育部明确了应用型人才培养对促进新经济发展的关键意义，推动职业教育在人才生态、思维模式、知识体系、能力技术等方面的探索与转型。
          </p>
          <!-- <p class="industry_text2"></p> -->
          <ul class="industry_title">
            <li>
              <div><img src="@/zh-website/src/assets/ideas1.png" alt="" /></div>
              <div>
                <h3>行业未来</h3>
                <p>
                  人才是行业发展的源动力
                </p>
              </div>
            </li>
            <li>
              <div><img src="@/zh-website/src/assets/ideas2.png" alt="" /></div>
              <div>
                <h3>华为方案</h3>
                <p>
                  “平台+生态”播种ICT人才黑土地
                </p>
              </div>
            </li>
            <li>
              <div><img src="@/zh-website/src/assets/ideas3.png" alt="" /></div>
              <div>
                <h3>人才缺口</h3>
                <p>
                  行业数字化转型存在人才缺口
                </p>
              </div>
            </li>
          </ul>
          <p class="industry_text3">
            华为一直倡导构建开放、共享、共赢的ICT人才生态体系，联接教育主管部门、院校、教育机构、合作伙伴等各方角色，产学研协同，共同孕育ICT产业未来。浙江华为作为华为专注于数字化人才发展的子公司，持续探索教育领域十余载，基于华为在5G、人工智能、物联网、大数据、云计算等方向的技术积累，深化研究院校ICT人才发展新路径，加强院校学生理论与实践的融合，培养当代新型ICT复合型技术技能人才。
          </p>
        </div>
        <div class="conent_box developing_box">
          <h3>内涵建设思路</h3>
          <i class="selected"></i>
          <div class="_text">
            遵循教育本质，践行院校内涵式建设
          </div>
          <ul class="developing">
            <li>
              <div class="developing_title">
                <img src="@/zh-website/src/assets/ideas4.png" alt="" />
                <p>人才教育升级</p>
              </div>
              <div class="developing_cont">
                <div class="developing_top">
                  <div>
                    <img src="@/zh-website/src/assets/ideas7.png" alt="" />
                    <p>教学实施</p>
                  </div>
                  <div>
                    <img src="@/zh-website/src/assets/ideas8.png" alt="" />
                    <p>综合素养</p>
                  </div>
                </div>
                <div class="developing_bottom">
                  <div>
                    <img src="@/zh-website/src/assets/ideas7.png" alt="" />
                    <p>产业链人才联盟</p>
                  </div>
                  <div>
                    <img src="@/zh-website/src/assets/ideas8.png" alt="" />
                    <p>专场招聘会</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="developing_title">
                <img src="@/zh-website/src/assets/ideas5.png" alt="" />
                <p>办学水平提升</p>
              </div>
              <div class="developing_cont">
                <div class="developing_top">
                  <div>
                    <img src="@/zh-website/src/assets/ideas11.png" alt="" />
                    <p>专业建设</p>
                  </div>
                  <div>
                    <img src="@/zh-website/src/assets/ideas12.png" alt="" />
                    <p>教学资源库建设</p>
                  </div>
                </div>
                <div class="developing_top">
                  <div>
                    <img src="@/zh-website/src/assets/ideas13.png" alt="" />
                    <p>师资队伍建设</p>
                  </div>
                  <div>
                    <img src="@/zh-website/src/assets/ideas14.png" alt="" />
                    <p>双创教育</p>
                  </div>
                </div>
                <div class="developing_bottom">
                  <div>
                    <img src="@/zh-website/src/assets/ideas15.png" alt="" />
                    <p>奖项申报</p>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div class="developing_title">
                <img src="@/zh-website/src/assets/ideas6.png" alt="" />
                <p>内涵式建设与发展</p>
              </div>
              <div class="developing_cont">
                <div class="developing_top">
                  <div>
                    <img src="@/zh-website/src/assets/ideas16.png" alt="" />
                    <p>稳定规模</p>
                  </div>
                  <div>
                    <img src="@/zh-website/src/assets/ideas17.png" alt="" />
                    <p>整合资源</p>
                  </div>
                </div>
                <div class="developing_top">
                  <div>
                    <img src="@/zh-website/src/assets/ideas18.png" alt="" />
                    <p>夯实基础</p>
                  </div>
                  <div>
                    <img src="@/zh-website/src/assets/ideas19.png" alt="" />
                    <p>优化结构</p>
                  </div>
                </div>
                <div class="developing_bottom">
                  <div>
                    <img src="@/zh-website/src/assets/ideas20.png" alt="" />
                    <p>提高质量</p>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <!-- 专业建设方案 -->
        <div class="conent_box Build_box">
          <h3>专业建设方案</h3>
          <i class="selected"></i>
          <div class="_text">
            顺应科技大潮，培养物联网实战人才
          </div>
          <div class="Build">
            <div class="Build_text">
              <div class="Build_text1">
                <h4>基于行业所需 构筑能力模型</h4>
                <p>
                  以百余家物联网企业为样本，进行调研分析，充分认识企业对物联网人才的真正需求。同时基于物联网行业人才需求，提出基于岗位分析的人才能力模型。
                </p>
              </div>
              <div class="Build_text1">
                <h4>结合教学实际 设计课程体系</h4>
                <p>
                  基于院校专业设置与企业技术发展应用实际情况，结合院校原有物联网及相关专业通识基础课程，输入企业领先的物联网技术核心课程，制定契合职教的专业课程体系与人才培养方案。
                </p>
              </div>
              <div class="Build_text1">
                <h4>理论结合实践 配置实训平台</h4>
                <p>
                  基于华为物联网“1+2+1”解决方案，结合行业实际与教育需求，面向院校物联网专业设计物联网实训基地，并匹配华为物联网认证所需能力要求，满足院校产、教、研融合的需求。
                </p>
              </div>
            </div>
            <div class="Build_img">
              <img src="@/zh-website/src/assets/network2.png" alt="" />
            </div>
          </div>
          <ul class="personnel">
            <li>
              <img src="@/zh-website/src/assets/ideas21.png" alt="" />
              <h3>行业调研</h3>
              <div class="angle"></div>
            </li>
            <li>
              <img src="@/zh-website/src/assets/ideas22.png" alt="" />
              <h3>岗位分析</h3>
              <div class="angle"></div>
            </li>
            <li>
              <img src="@/zh-website/src/assets/ideas23.png" alt="" />
              <h3>技能分析</h3>
              <div class="angle"></div>
            </li>
            <li>
              <img src="@/zh-website/src/assets/ideas24.png" alt="" />
              <h3>知识匹配</h3>
              <div class="angle"></div>
            </li>
            <li>
              <img src="@/zh-website/src/assets/ideas25.png" alt="" />
              <h3>课程开发</h3>
              <div class="angle"></div>
            </li>
            <li>
              <img src="@/zh-website/src/assets/ideas26.png" alt="" />
              <h3>实验匹配</h3>
            </li>
          </ul>
        </div>
        <!-- 产教融合愿景 -->
        <div class="conent_box Vision">
          <h3>产教融合愿景</h3>
          <i class="selected"></i>
          <div class="_text">
            深化“产教融合”，培养创新型应用技术人才
          </div>
          <p class="industry_text1">
            院校与浙江华为强强联手、优势互补，紧密结合行业发展趋势及新型岗位需求，按人才缺口与就业发展机遇制定办学规划，实现院校、企业、学生的多方共赢，促进学校内涵式建设、扩大院校品牌影响力。
          </p>
          <p class="industry_text2">
            形成“产教研一体化”、“产教融合”的教学模式，充分发挥各方优势，为学生、教师制定与时俱进的培养方案。提供定制化、综合化、创新化的教学与实践环境，武装学生、教师的理论知识与实践技能，培养社会经济转型亟需的高端技术技能人才。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Vue, Prop, Component, Watch } from "vue-property-decorator";

@Component({
  components: {
    
  }
})
export default class Ideas extends Vue {
  list={
        style: {
          "background-image": `url(${require("@/zh-website/src/assets/banner_certification.png")})`,
          height: "493px"
        },
        font1: "人工智能专业建设",
        font2: "",
        font3: "",
        font4: "全场景、端到端",
        font5: "培养智能时代智慧人才",
        button: ""
      }
      setSelcted(index) {
      this.$refs.carousel.setActiveItem(index);
    }
}
</script>
<style lang="less" scoped>
// 切换导航栏显示内容
._center {
  padding-bottom: 3.4375rem;
  max-width: 1366px;
  margin: 0 auto;
}
.conent {
  .conent_box {
    background-color: #f8f8f8;
    // height: 500px;
    padding: 2.8125rem 5rem 7.5rem;
    margin-bottom: 0.9375rem;
    h3 {
      font-size: 1.75rem;
      text-align: center;
      color: #333;
    }
    .selected {
      display: block;
      width: 1.5625rem;
      height: 0.1875rem;
      background-color: #333333;
      margin: 0.625rem auto 0;
    }
    ._text {
      width: 100%;
      text-align: center;
      color: #999999;
      margin: 1.25rem auto 1.875rem;
    }
    .industry_text3,
    .industry_text2,
    .industry_text1 {
      font-size: 1.125rem;
      margin-top: 2.1875rem;
      color: #666;
    }
    .industry_title {
      padding: 1.875rem 5.3125rem 0;
      display: flex;
      justify-content: space-between;
      li {
        height: 12.6875rem;
        width: 20.375rem;
        border: 1px solid #ccc;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        h3 {
          font-size: 1.5rem;
        }
        p {
          font-size: 1.125rem;
          margin-top: 5px;
          text-align: center;
        }
      }
    }
  }
  // 内涵建设思路
  .developing_box {
    padding: 2.8125rem 5rem 2.5rem;

    .developing {
      display: flex;
      justify-content: space-between;
      font-size: 1.25rem;
      li {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-content: center;
        // background-color: red;
        border-left: 0.0625rem solid #ccc;
        padding: 0 0.9375rem;
        &:nth-child(1) {
          border-left: 0 solid #ccc;
        }
        .developing_title {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          height: 4.5rem;
          background-color: #7d7d7d;
          border-radius: 0.625rem;
          font-weight: 700;
          color: #fff;
          padding: 0 4.375rem;
        }
        .developing_cont {
          display: flex;
          flex-direction: column;
          font-size: 1.125rem;
          font-weight: 600;
          color: #333;
          .developing_top {
            display: flex;
            justify-content: space-around;
            div {
              display: flex;
              flex: 1;
              flex-direction: column;
              justify-content: flex-end;
              align-items: center;
              background-color: #fff;
              margin-top: 0.625rem;
              border-radius: 0.625rem;
              padding: 0.9375rem 0;
              &:nth-child(1) {
                margin-right: 0.625rem;
              }
              p {
                padding-top: 0.1875rem;
              }
            }
          }
          .developing_bottom {
            display: flex;
            flex-direction: column;
            align-items: center;
            div {
              display: flex;
              display: -webkit-box;
              width: 100%;
              justify-content: space-evenly;
              align-items: center;
              background-color: #fff;
              margin-top: 0.625rem;
              padding: 1.875rem 5.75rem;
              border-radius: 0.625rem;
            }
          }
        }
      }
    }
  }
  // 专业建设方案
  .Build_box {
    padding: 3rem 1.875rem 0 2.75rem;
    .Build {
      display: flex;
      justify-content: space-between;
      .Build_text {
        flex: 1;
        background-color: rgb(255, 255, 255);
        box-shadow: 5.446px 8.387px 7px 0px rgba(0, 0, 0, 0.06);
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 5.625rem 3.75rem;
        margin-right: 2.1875rem;
        .Build_text1 {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-evenly;
          padding-top: 1.8125rem;
          border-bottom: 0.0625rem solid #ccc;
          h4 {
            color: #333;
            font-size: 1.25rem;
            font-weight: 600;
          }
          p {
            font-size: 1rem;
            color: #666;
            padding: 0 1rem;
            line-height: 170%;
          }
        }
      }
      .Build_img {
        background-color: rgb(51, 51, 51);
        box-shadow: 0px 11px 7px 0px rgba(0, 0, 0, 0.16);
        width: 26.1875rem;
        height: 39.75rem;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        img {
          height: 100%;
        }
      }
    }
    // 分类
    .personnel {
      display: flex;
      padding: 1.875rem 0 2.5rem;
      li {
        position: relative;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-evenly;
        height: 165px;
        align-items: center;
        background-color: #fff;
        padding-top: 1.6875rem;
        color: #333;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        h3 {
          font-size: 1rem;
          font-weight: 600;
        }

        .angle {
          background-color: #fff;
          position: absolute;
          top: 50%;
          right: 0.1875rem;
          width: 0;
          height: 0;
          border-width: 0.625rem;
          border-style: solid;
          border-color: transparent transparent #fff #fff;
          transform: translate(50%, -50%) rotate(-135deg);
          z-index: 333;
          box-shadow: -4px 2px 3px -1px rgba(0, 0, 0, 0.1);
        }
      }
    }
  }
  // 产教融合愿景
  .Vision {
    padding-bottom: 3.125rem;
    .industry_text1,
    .industry_text2 {
      color: #333;
      font-size: 1.125rem;
    }
  }
}
@media screen and (max-width: 1366px) {
  .WidCon {
    padding: 0 5%;
  }
  .conent .conent_box .industry_title {
    padding: 1.875rem 20px;
  }
}
@media screen and (max-width: 1200px) and (min-width: 901px) {
  .conent .resources .course .course_img {
    display: none;
  }
  .conent .developing_box .developing {
    flex-wrap: wrap;
  }
  .conent .developing_box .developing li {
    border: none;
    margin-bottom: 10px;
  }
  .conent
    .developing_box
    .developing
    li
    .developing_cont
    .developing_bottom
    div {
    width: auto;
  }
}
@media screen and (max-width: 985px) and (min-width: 769px) {
  .conent .resources .course .course_img {
    display: none;
  }
  .conent .developing_box .developing {
    flex-wrap: wrap;
  }
  .conent .developing_box .developing li {
    border: none;
    margin-bottom: 10px;
  }
  .conent
    .developing_box
    .developing
    li
    .developing_cont
    .developing_bottom
    div {
    width: auto;
  }
}
@media screen and (max-width: 768px) {
  // 背景
  .Banner {
    .BannerFont {
      h1 {
        font-size: 24px;
      }
      p,
      div {
        font-size: 20px;
      }
    }
  }
  // 导航
  .ExpertNav ul {
    flex-wrap: wrap;
    justify-content: space-evenly;
    li {
      border-left: 1px solid #ccc;
      margin-top: 0.3125rem;
    }
  }
  //行业与政策
  .conent {
    .conent_box {
      padding: 0.625rem;
      h3 {
        padding-top: 1.25rem;
      }
      ._text {
        margin: 10px auto 20px;
      }
      .industry_text3 {
        margin-top: 15px;
      }
      .industry_title {
        flex-direction: column;
        // flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        padding-bottom: 0;
        li {
          margin-bottom: 5px;
          // width: 100%;
        }
      }
    }
    // 内涵建设思路
    .developing_box {
      .developing {
        flex-direction: column;
        li {
          margin-bottom: 1.25rem;
          border-left: 0px;
        }
      }
    }
    // 专业建设方案
    .Build_box {
      .Build {
        flex-direction: column;
        align-items: center;
        .Build_text {
          padding: 0 5px 20px;
          margin: 0;
          .Build_text1 {
            padding-top: 10px;
          }
        }
        .Build_img {
          margin-top: 1.25rem;
          width: 100%;
          height: 17rem;
          overflow: hidden;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
      //
      .personnel {
        display: block;
        overflow: hidden;
        padding-bottom: 20px;
        li {
          overflow: hidden;
          padding: 10px;
          margin: 5px;
          width: calc(33% - 10px);
          float: left;
          height: 120px;
          h3 {
            padding-top: 10px;
          }
        }
      }
    }
  }

  .conent .conent_box h3 {
    font-size: 18px;
  }

  .conent_box .industry_text1 {
    font-size: 14px !important;
    margin-top: 20px !important;
  }

  .conent_box .industry_text2 {
    font-size: 14px !important;
  }

  .conent .conent_box .industry_title li p {
    font-size: 14px;
  }
  .conent .conent_box .industry_title li h3 {
    font-size: 16px;
  }

  .conent .conent_box .industry_text3 {
    font-size: 14px;
  }

  .conent .Build_box .Build .Build_text .Build_text1 h4 {
    font-size: 16px;
    font-weight: bold;
  }

  .conent .Build_box .Build .Build_text .Build_text1 p {
    font-size: 14px;
    padding: 0;
  }

  .conent .Build_box .Build .Build_text .Build_text1 {
    padding-left: 10px;
    padding-right: 10px;
  }
}
</style>
